import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TeacherAssessment from './pages/TeacherAssessment';
import StudentSurvey from './pages/StudentSurvey';
import IndustryPartnerAssessment from './pages/IndustryPartnerAssessment';
import SupervisorAssessment from './pages/SupervisorAssessment';
import ParentAssessment from './pages/ParentAssessment';
import SchoolList from './pages/SchoolList';
import SchoolDetail from './pages/SchoolDetail';
import PrincipalSummary from './pages/PrincipalSummary';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, loading, profile } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow access if user has the required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(profile?.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['principal', 'supervisor']}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/principal-summary"
            element={
              <ProtectedRoute allowedRoles={['principal', 'supervisor']}>
                <PrincipalSummary />
              </ProtectedRoute>
            }
          />
          
          <Route 
            path="/teacher-assessment" 
            element={
              <ProtectedRoute allowedRoles={['teacher']}>
                <TeacherAssessment />
              </ProtectedRoute>
            } 
          />
          
          <Route
            path="/industry-partner-assessment"
            element={
              <ProtectedRoute allowedRoles={['industry_partner']}>
                <IndustryPartnerAssessment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/supervisor-assessment"
            element={
              <ProtectedRoute allowedRoles={['supervisor']}>
                <SupervisorAssessment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/parent-assessment"
            element={
              <ProtectedRoute allowedRoles={['parent']}>
                <ParentAssessment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/student-survey"
            element={
              <ProtectedRoute allowedRoles={['student']}>
                <StudentSurvey />
              </ProtectedRoute>
            }
          />

          <Route path="/schools" element={<SchoolList />} />
          <Route path="/school/:id" element={<SchoolDetail />} />

          {/* Landing page as default route */}
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
